(function ($) {
    var convertCalculator = {
        convertCalculator: function () {
            var $container = $(this);
            if ($container.length === 0)
                return false;

            var $price = $container.find('.price').find('span');
            var price;
            var basePrice = price = parseInt($price.html().replace(/\D+/g, ''));
            var heatPrice = 0;
            var chairPrice = 0;
            var selectedHeatType = 0;

            function format(price) {
                return formatNumber(price, 0, '', ' ');
            }

            $price.on('change', function () {
                var prefix = '';
                if (selectedHeatType === 0)
                    prefix = 'от ';
                $price.html(prefix + format(heatPrice + basePrice + chairPrice));
            });

            $container.find('.heat-types').find('input[type=radio]').change(function () {
                heatPrice = parseInt($(this).data('price'));
                selectedHeatType = parseInt($(this).val());
                $price.change();
            });

            $container.find('.chair-types').find('input[type=radio]').change(function () {
                chairPrice = parseInt($(this).data('price'));
                $price.change();
            });

            $container.find('.heat-types').find('input[type=radio]:checked').change();
        }
    };
    $.fn.extend(convertCalculator);
    //страница конструктора
    $(".select-block .radio textarea").focus(function () {
        $(this).parent().find("[type=radio]").attr("checked", "checked").change();
    });
    $(".konstruktor-form").convertCalculator();
})(jQuery);

//констрктор
(function (document, window, index) {
    var inputs = document.querySelectorAll('.inputfile');
    Array.prototype.forEach.call(inputs, function (input) {
        var label = input.nextElementSibling,
            labelVal = label.innerHTML;

        input.addEventListener('change', function (e) {
            var fileName = '';
            if (this.files && this.files.length > 1)
                fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
            else
                fileName = e.target.value.split('\\').pop();

            if (fileName)
                label.querySelector('span').innerHTML = fileName;
            else
                label.innerHTML = labelVal;
        });

        // Firefox bug fix
        input.addEventListener('focus', function () {
            input.classList.add('has-focus');
        });
        input.addEventListener('blur', function () {
            input.classList.remove('has-focus');
        });
    });
}(document, window, 0));
